<template>
    <div
        :class="{ 'c-modal--open': open }"
        class="c-modal">
        <div v-if="innerOpen" class="c-modal__inner" :class="innerClass">
            <slot></slot>
        </div>
    </div>
</template>


<script>

export default {

    name: 'VModal',

    props: {
        open: Boolean,
        innerClass: [Object, String]
    },
    data() {
        return {
            innerOpen: false
        }
    },

    watch: {
        open(open) {
            if (!open) {
                setTimeout(() => {
                    this.innerOpen = false
                }, 300)
            } else {
                this.innerOpen = true
            }
        }
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    background-color: rgba(255, 255, 255, 0.95);
    opacity: 0;
    visibility: hidden;
    transition: opacity .3s ease-in-out, visibility 0s .3s linear;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 10vh 0;
    overflow: auto;
    pointer-events: none;

    &--open {
        transition-delay: 0s;
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
    }
    &__inner {
        width: 90%;
        max-width: 460px;
        border: 1px solid $c-border;
        border-radius: 4px;
        background-color: #fff;
        padding: 40px;
        color: $c-third;

        @include bp($screen-sm) {
            padding: 20px;
        }
    }
}

</style>
